// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mUM-","top":"styles_top__3APrn","left":"styles_left__1ckB-","description":"styles_description__jATgJ"};